<mat-radio-group
  class="sg-ui-component"
  [ngClass]="alignment === 'vertical' ? 'vertical-group' : 'horizontal-group'"
  [disabled]="disabled"
  [value]="selectedValue"
  (change)="onValueChange($event.value)">
  @for (item of items; track $index) {
    <mat-radio-button [value]="item.value" [class.error]="!!errorMessage" [disableRipple]="true" class="sg-ui-component">
      @if (item.label) {
        <sg-text variant="sg-label-medium-regular" class="label">{{ item.label }}</sg-text>
      }
    </mat-radio-button>
  }
</mat-radio-group>
@if (errorMessage) {
  <sg-text variant="sg-body-small-regular" class="error-message">{{ errorMessage }}</sg-text>
}
